// Components
import { Card, FooterMenu, HeaderMenu, Loading } from "components"
import { EditSection, ListSection } from "./components"

// Utils
import { useList } from "./utils"
import { useContext } from "react"
import { ListContext, ListProvider } from "./contexts"
import { ExportExcel } from "./components/ExportExcel"
import { exportPdf } from "utils"
import { ExportPdf } from "./components/ExportPdf"

export default function OpeningBalance() {

  return (
    <ListProvider>
      <section className="container my-5">
        <HeaderMenu title="DATA ENTRY | OPENING BALANCE" className="sticky top-[32px] z-[1]" />

        <Card>
          <Card.Body className="!text-xl font-bold">
            <TableSection />
          </Card.Body>
        </Card>

        <Footer />
      </section>
    </ListProvider>
  )
}



function TableSection() {
  // Hooks
  const { data, date, isEdit, isLoading, setData, setDate, setEdit } = useList()


  if (isLoading) {
    return <Loading loading={isLoading} />
  } else if (isEdit) {
    return <EditSection date={date} list={data} />
  } else {
    return (
      <ListSection
        date={date}
        list={data}
        onSuccess={(list, date) => {
          setData(
            list.map((item) => {
              return {
                ...item,
                old_opening_balance: item.opening_balance
              }
            })
          )
          setEdit(true)
          setDate(date)
        }}
      />
    )
  }
}

function Footer() {
  const { item, filter } = useContext(ListContext)

  return (
    <section className="mt-2">
      <FooterMenu
        hasCancelButton
        export={{
          actiontype: "export",
          onClick: () => ExportExcel({ 
              data: item, 
              filter: filter 
            })
        }}
        pdf={{ 
          actiontype: "pdf",
          onClick: () => {
            exportPdf({
              documentComponent: <ExportPdf data={item} filter={filter} />,
              fileName: "Opening_Balance"
            })
          }
         }}
      />
    </section>
  )
}
